import SvgPolyIcon from "../cart-item-icons/SvgPolyIcon";

const CarItemUnitDropDownMenuTitle = () => {
  return (
    <div className="cart-item-units-menu-title">
      Select Unit <SvgPolyIcon />
    </div>
  );
};

export default CarItemUnitDropDownMenuTitle;
